import useAnnouncementName from 'hooks/createAnnouncementName';
import { useItemHandleFragment$data } from './__generated__/useItemHandleFragment.graphql';

export const useItemName = (item: useItemHandleFragment$data) => {
  const createAnnouncementName = useAnnouncementName();

  switch (item.__typename) {
    case 'Vault':
      return item.name || ''; // For type safety
    case 'Announcement':
      return createAnnouncementName(
        item.link?.item?.name,
        item.announcementDate ? new Date(item.announcementDate) : undefined,
        item.announcer?.name,
      );
    case 'AnnouncementAttachment':
    case 'MemberDetailsAttachment':
      return item.content?.__typename === 'File' ? item.content.name : '';
    default:
      return item.name || '';
  }
};
